module.exports = __webpack_public_path__ + "static/Hawes-and-curtis-logo-d7112f7fc34804cdce33c3fa5a9ff9a9.svg";